// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"b1f6ae83","787":"28cb0dcd","989":"57a31f7b"}[chunkId] + ".chunk.js";
};